import { render, staticRenderFns } from "./footprintItem.vue?vue&type=template&id=70e25d2d&"
import script from "./footprintItem.vue?vue&type=script&lang=js&"
export * from "./footprintItem.vue?vue&type=script&lang=js&"
import style0 from "./footprintItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports